export default "__VITE_ASSET__CufkCdN8__"